// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3wT1I","errorLogs":"styles_errorLogs__3t6pT"};